module.exports = __webpack_public_path__ + "static/media/gi.82d70192.svg";